// @ts-nocheck
/**
 * Section 318 constructive-ownership relationships shown in the Vote Room exclusion modal.
 *
 * `value` is the short code persisted on `Shareholder.section318Relationship`; `label` is the
 * human string rendered in the dropdown. Keep this list in one place so the cap table backend
 * rule (`enum-string-title-case`) and the UI agree.
 */
export const SECTION_318_RELATIONSHIPS = [
  { value: 'spouse', label: 'Spouse' },
  { value: 'child', label: 'Child' },
  { value: 'grandchild', label: 'Grandchild' },
  { value: 'parent', label: 'Parent' },
  { value: 'trust', label: 'Trust for the individual' },
  { value: 'estate', label: 'Estate' },
  { value: 'partnership', label: 'Partnership (>50% interest)' },
  { value: 'corporation', label: 'Corporation (>50% value)' },
];

/** Reusable Tailwind class strings for Vote Room wizard buttons (canonical definitions in WorkflowFormPrimitives). */
export {
  workflowPrimaryButtonClass as VR_BTN_PRIMARY,
  workflowBackButtonClass as VR_BTN_BACK,
  workflowToolbarButtonClass as VR_BTN_TOOLBAR,
  workflowToolbarPrimaryButtonClass as VR_BTN_TOOLBAR_PRIMARY,
} from '../../../../components/WorkflowFormPrimitives';

/** Shared card surface used by wizard steps. */
export const VR_CARD = 'bg-white border border-gray-200/80 rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.04)]';

/** Width applied to the Vote Room slide-over panel by default (non-maximized). */
export const VOTE_ROOM_SLIDE_DEFAULT_WIDTH = '!w-[60%] max-w-[60%]';
/** Width applied when the slide-over panel is maximized. */
export const VOTE_ROOM_SLIDE_MAXIMIZED_WIDTH = '!w-full max-w-full';

/** Live Vote Room shareholder list — name flexes; numeric/status/actions use stable min/max tracks. */
export const LIVE_SHAREHOLDER_GRID =
  'minmax(11rem, 1fr) minmax(4.5rem, 6.5rem) minmax(5.5rem, 7rem) minmax(5.5rem, 7.5rem) minmax(5.5rem, 7rem) 6.5rem';

/** Pre-launch email check polling and verified-status gates. */
export const PRECHECK_POLL_INTERVAL_MS = 2000;
export const PRECHECK_POLL_MAX_MS = 30000;
export const PRECHECK_VERIFIED_STATUSES = ['Confirmed'];
export const PRECHECK_RESOLVED_STATUSES = ['Sent', 'Confirmed', 'Failed'];

export const isAllPrecheckVerified = (rows) =>
  rows.length === 0 || rows.every((s) => PRECHECK_VERIFIED_STATUSES.includes(s.emailPrecheckStatus || ''));
